// extracted by mini-css-extract-plugin
export var animate = "video-module--animate--ddd32";
export var clipWrapper = "video-module--clip-wrapper--27e89";
export var embedWrapper = "video-module--embedWrapper--80c80";
export var playButton = "video-module--playButton--a064e";
export var playButtonArea = "video-module--playButtonArea--26962";
export var preRollPlayer = "video-module--preRollPlayer--684d3";
export var reactPlayer = "video-module--react-player--243d5";
export var showEmbed = "video-module--show-embed--54bb5";
export var videoContent = "video-module--videoContent--ea76d";
export var videoDuration = "video-module--videoDuration--86af8";
export var videoModule = "video-module--videoModule--4cc0f";
export var videoOverlayTitle = "video-module--videoOverlayTitle--943e7";
export var videoOverlayTitleWrapper = "video-module--videoOverlayTitleWrapper--73763";